import React from 'react';
import { Controller } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { MuiOtpInput } from 'mui-one-time-password-input';
import useSignUpHooks from '../signUp-hooks';
import { useGeneralHooks } from '../../../Hooks/hooks';
import { usePassword } from '../../../Components/Inputs/input-hooks';
import RoundLogo from '../../../Components/Logos/RoundLogo/roundLogo';
import { ButtonTypes, SignUpScreens } from '../../../Interfaces/componentTypes';
import AuthInput from '../../../Components/Inputs/AuthInput/authInput';
import Languages from '../../../Components/Languages/languages';
import TelInput from '../../../Components/Inputs/TelInput/telInput';
import Button from '../../../Components/Button/button';
import { HidePassword, ShowPassword } from '../../../Assets/Icons';
import styles from '../signUp.module.scss';

const SignUpPC: React.FC = () => {
  const { t, navigate } = useGeneralHooks();
  const { password, changeType } = usePassword();
  const { handleSubmit, register, control, handleRecieveCode, onSignUp, onVerify, screenType, errors, signUpLoading, verifyLoading, recieveCodeLoding } = useSignUpHooks();

  return (
    <div className={styles.page}>
      <div className={styles.leftSide} />
      <div className={styles.rightSide}>
        <div className={styles.languages}>
          <Languages />
        </div>
        <RoundLogo onClick={() => navigate('/')} />
        {
          screenType === SignUpScreens.SignUp
            ?
            <form onSubmit={handleSubmit(onSignUp)} className={styles.form}>
              <p className={styles.header}>{t('Sign_Up.Title')}</p>
              <AuthInput
                register={register}
                registerName='username'
                label={t('Sign_Up.UserName')}
                error={errors.username}
              />
              <AuthInput
                register={register}
                type='email'
                registerName='email'
                label={t('Sign_Up.Email')}
                patternValue={/^\s*[A-ZA-z0-9._%+-]+@[A-Za-z0-9.-]+[A-Za-z]{2,}\s*$/gim}
                message={t('Errors.Email')}
                error={errors.email}
              />
              <TelInput
                name='phone_number'
                control={control}
                label={t('Sign_Up.Phone')}
                error={errors.phone_number}
              />
              <AuthInput
                register={register}
                registerName='password'
                label={t('Sign_Up.Password')}
                type={password ? 'password' : 'text'}
                patternValue={
                  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#/+_,.^])[A-Za-z\d@$#!%*.,^/+_?&]{8,}$/gm
                }
                message={t('Errors.Password')}
                error={errors.password}
                inputBoxStyles={styles.passwordInput}
                children={
                  <img
                    className={styles.inputIcon}
                    src={password ? HidePassword : ShowPassword}
                    alt="eyeIcon"
                    onClick={changeType}
                  />
                }
              />
              <Button
                type='submit'
                buttonType={ButtonTypes.Primery}
                title={t('Sign_Up.Button')}
                buttonStyle={styles.button}
                isLoading={signUpLoading}
              />
              <p className={styles.loginLink}>
                {t('Sign_Up.HaveAccount')} <span onClick={() => navigate('/login')} className={styles.linkText}>{t('Sign_Up.Login')}</span>
              </p>
            </form>
            :
            <form onSubmit={handleSubmit(onVerify)} className={styles.form}>
              <span className={styles.veryfyText}>
                <Trans i18nKey="Sign_Up.Verify" components={{ 1: <span onClick={handleRecieveCode} className={styles.resendLink} /> }} />
              </span>
              <Controller
                name="verifyCode"
                control={control}
                rules={{
                  validate: (value) => value && value.length === 4 || t('Errors.Code'),
                }}
                render={({ field, fieldState }) => (
                  <>
                    <MuiOtpInput
                      aria-required
                      sx={{ gap: 1 }}
                      {...field}
                      length={4}
                      TextFieldsProps={{
                        type: 'tel',
                        inputMode: 'numeric',
                        autoComplete: 'one-time-code',
                      }}
                    />
                    {fieldState.error && (
                      <p className={styles.otpWarn}>{t('Errors.Code')}</p>
                    )}
                  </>
                )}
              />
              <Button
                type='submit'
                buttonType={ButtonTypes.Primery}
                title='Verify'
                buttonStyle={styles.button}
                isLoading={verifyLoading || recieveCodeLoding}
              />
            </form>
        }

      </div>
    </div>
  )
}

export default SignUpPC
